import { inject, Injectable } from '@angular/core';
import { SitesService } from '@app/client';
import { map, Observable, of } from 'rxjs';
import { ISelectItem } from '../interfaces/select-item.interface';

@Injectable()
export class SitesSharedService {
  private sitesService = inject(SitesService);

  getSiteOptions(): Observable<ISelectItem[]> {
    return this.sitesService.findAll().pipe(
      map((res) =>
        res.map((r) => ({
          label: r.name,
          value: r._id,
        })),
      ),
    );
  }

  getAreaOptions(): Observable<ISelectItem[]> {
    return of(
      [1, 2, 3, 4, 5, 6].map((r) => ({
        label: `Area ${r}`,
        value: r,
      })),
    );
  }
}
